var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('vue-bottom-sheet',_vm._b({ref:"sheet",class:{
    'theme--dark': _vm.$vuetify.theme.dark,
    'click-to-close': _vm.clickToClose,
  },attrs:{"overlay":_vm.overlay,"rounded":_vm.rounded,"max-height":_vm.maxHeight,"max-width":_vm.maxWidth,"click-to-close":_vm.clickToClose,"effect":_vm.effect},on:{"closed":_vm.onClose,"opened":_vm.onOpen}},'vue-bottom-sheet',_vm.$attrs,false),[_c('v-slide-y-reverse-transition',[(_vm.show)?_vm._t("default"):_vm._e()],2)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }